import { createContext, useContext } from "react";

type DraftContextValue = {
  isReadOnly: boolean;
  estimatingMethod?: string;
};

const DraftContext = createContext<DraftContextValue>({ isReadOnly: false });
export default DraftContext;

export function useDraftContext() {
  return useContext(DraftContext);
}
